export default __webpack_public_path__ + "static/media/payroll_highlighted.08fb8e60.svg";